<template>
  <div class="ma-4">
    <v-dialog v-model="dialogaddreview" persistent max-width="500">
      <v-card>
        <v-card-title>Tulis Ulasan</v-card-title>
        <v-card-text>
          <label class="">Berikan bintang dan ulasan kepada penjual</label>
              <div class="mt-2">
                <v-rating
                    v-model="newdata.bintang"
                    background-color="accent"
                    color="accent"
                    dense
                    hover
                    size="18"
                ></v-rating>
              </div>
            <v-textarea
                class="mt-4"
                outlined
                name="input-7-4"
                label="Review"
                v-model="newdata.comment"
            ></v-textarea>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn elevation="0" dark @click="setdialogaddreview(false)" class="red">Tutup</v-btn>
          <v-btn @click="kirimreview" :disabled="readykirim" elevation="0" class="primary">Kirim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn @click="opendialog" text class="primary"><v-icon class="mr-2">comment</v-icon>Tulis Review</v-btn>
    <v-layout row wrap class="mt-2">
      <v-flex lg3  sm6 xs12 v-for="(item, index) in reviews"  :key="index">
        <v-card elevation="1" class="ma-2">
          <v-card-text>
            <div>{{item.membername}}</div>
            <div>
              <v-avatar><img :src="item.memberavatar" alt="avatar"></v-avatar>
            </div>
            <v-rating
                :value="item.bintang"
                color="amber"
                dense
                half-increments
                readonly
                size="14"
            ></v-rating>
            <div>
              <b>{{item.comment}}</b>
            </div>
            <div class="mt-2" style="font-size: 12px">{{formatDate(item.createat)}}</div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'SellerReview',
  data: () => ({
    option: {
      memberid: 3033
    },
    newdata: {
      bintang: 0,
      comment: '',
      memberid: 0
    }
  }),
  mounted () {
    this.newdata.memberid = this.$route.params.id
    // this.getReviews(this.option)
  },
  computed: {
    ...mapState('ReviewStore', ['reviews', 'totalreview', 'dialogaddreview']),
    readykirim () {
      return this.newdata.bintang === 0 || this.newdata.comment.length === 0
    }
  },
  methods: {
    ...mapActions('ReviewStore', ['getReviews', 'addReview', 'setdialogaddreview']),
    opendialog () {
      this.newdata.bintang = 0
      this.newdata.comment = ''
      this.memberid = this.$route.params.id
      this.setdialogaddreview(true)
    },
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    kirimreview () {
      this.newdata.memberid = this.$route.params.id
      this.$ga.event({
        eventCategory: 'Seller',
        eventAction: 'AddReview',
        eventLabel: this.$route.params.id,
        eventValue: this.newdata.bintang
      })
      this.addReview(this.newdata)
    }
  }
}
</script>

<style scoped>

</style>
